import { nextPreload, useProxyWatchUpdates, useTranslation } from '@fanfanlo';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import PeopleIcon from '@mui/icons-material/People';
import { AppBar, Avatar, Box, IconButton, Toolbar, Typography } from '@mui/material';
import { useRouter } from 'next/router';
import { matrixRoom } from '../../client/room';
import { useEffect } from 'react';

export interface RoomHeaderProps {
  roomId: string;
  showMembers: boolean;
  onToggleMembers: () => void;
}

export function RoomHeader({ roomId, showMembers, onToggleMembers }: RoomHeaderProps) {
  const { t } = useTranslation('homepage/im/components/room/content');
  const router = useRouter();
  const [roomInfo] = useProxyWatchUpdates(
    matrixRoom.roomData.joinedRoomsMap,
    [roomId],
    matrixRoom.roomData.joinedRoomsMap[roomId] || {}
  );
  
      useEffect(() => {
        nextPreload(router, '/im/room/room-settings?id=${roomId}');
      }, []);
  function onOpenSettingsClick(){
    router.push(`/im/room/room-settings?id=${roomId}`);
  }
  function handleBack(){
    router.back()
  }
  return (
    <AppBar position="static" color="default" elevation={1}>
      <Toolbar>
        <KeyboardArrowLeft onClick={handleBack} />
        <Box sx={{ mr: 2 }}>
          <Avatar src={roomInfo?.avatarUrl}>
            {roomInfo?.name?.charAt(0) || 'R'}
          </Avatar>
        </Box>
        <Typography
          variant="h6"
          component="div"
          sx={{
            flexGrow: 1,
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            mr: 2,
          }}
        >
          {roomInfo?.name || t('RoomHeader.unnamedRoom')}
        </Typography>
        <IconButton
          color={showMembers ? 'primary' : 'default'}
          onClick={onOpenSettingsClick}
          title={t('RoomHeader.toggleMembers')}
        >
          <PeopleIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}
